import { useState } from 'react'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { releaseNotes } from '@/lib/releaseNotes'
import { version } from '../../package.json'

export function PoweredByFooter() {
  const [open, setOpen] = useState(false)

  return (
    <div className="py-3 text-center">
      <div className="flex items-center justify-center gap-2 text-xs text-muted-foreground">
        <span>Powered by </span>
        <span className="font-semibold text-primary">REINZ</span>
        <span className="text-muted-foreground/40">·</span>
        <span className="text-muted-foreground/60">v{version}</span>
        <span className="text-muted-foreground/40">·</span>
        <button
          onClick={() => setOpen(true)}
          className="text-primary underline underline-offset-2 hover:opacity-70 transition-opacity"
        >
          Release notes
        </button>
      </div>
      <p className="mt-2 text-[10px] leading-relaxed text-muted-foreground/60 max-w-xs mx-auto">
        © {new Date().getFullYear()} Real Estate Institute of New Zealand (REINZ). All rights
        reserved. This prototype application, including all content, creative materials, and
        intellectual property contained herein, is the exclusive property of REINZ. Unauthorised
        reproduction, distribution, or duplication in any form is strictly prohibited.
      </p>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-h-[80vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>Release Notes</DialogTitle>
          </DialogHeader>
          <div className="space-y-6 pt-2">
            {releaseNotes.map((r) => (
              <div key={r.version}>
                <div className="flex items-center gap-2 mb-3">
                  <span className="text-sm font-semibold text-primary">v{r.version}</span>
                  <span className="text-xs text-muted-foreground">{r.date}</span>
                </div>
                <ul className="space-y-2">
                  {r.changes.map((c, i) => (
                    <li key={i} className="flex items-start gap-2 text-sm text-foreground">
                      <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-primary shrink-0" />
                      {c}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </DialogContent>
      </Dialog>
    </div>
  )
}
